import React, { memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { PALETTE, FONT_SIZES } from '~/assets/styles/base';

type StyledLabelProps = {
  $color?: string;
};

const StyledLabel = styled.span<StyledLabelProps>`
  display: inline-block;
  width: max-content;
  font-size: ${FONT_SIZES.note1};
  line-height: ${FONT_SIZES.body3};
  background: #fff;
  padding: 2.5px 10px;
  border-radius: 3px;
  text-align: center;
  border: 1px solid ${({ $color }) => $color ?? PALETTE.error.main};
  color: ${({ $color }) => $color ?? PALETTE.error.main};
  margin-right: 10px;
  min-height: 23px;
`;

type Props = {
  label?: string;
  color?: string;
};

const RequiredLabel: React.FC<Props> = ({ label, color }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledLabel $color={color} data-testid="uiElements-RequiredLabel">
      {label || t('appCommon.requiredLabel')}
    </StyledLabel>
  );
};

export default memo(RequiredLabel);
